import './Error.css';
import React, { useState } from 'react';

export function Error(props: { error: any; setError?: any }) {
  const { error } = props;
  const [hideError, setHideError] = useState(false);
  const onCloseClicked = (e) => {
    e.preventDefault();
    setHideError(true);
  };

  return (
    <>
      {error && !hideError && (
        <div className="ui negative message">
          <i onClick={(e) => onCloseClicked(e)} className="close icon" />
          <div>{JSON.stringify(error)}</div>
        </div>
      )}
    </>
  );
}
